<template>
  <div
    :class="{ 'component-box': true, center, radius }"
    v-if="data && Object.keys(data).length > 0"
    :style="{
      [data.horizontalDirection]:
        data && data.horizontalDistance ? data.horizontalDistance : 0,
      [data.verticalDirection]:
        data && data.verticalDistance ? data.verticalDistance : 0,
      color: data && data.fontColor ? data.fontColor : '#fff',
      backgroundImage:
        data && data.backgroundImage
          ? `url(${data.backgroundImage})`
          : 'inherit'
    }"
  >
    <template v-if="data">
      <slot></slot>
    </template>
  </div>
</template>
<script>
export default {
  props: ['data', 'center', 'radius']
};
</script>

<style lang="less" scoped>
.component-box {
  position: absolute;
  &.center {
    left: 50%;
    transform: translate(-50%, 0);
  }
  &.radius {
    border-radius: 31px;
  }
}
</style>
